export const API = `${window.location.origin}/api`;
